export const getTelegramInitData = (): string | null => {
  if (typeof window === "undefined") return null

  const tg = (window as any).Telegram?.WebApp
  console.log("Telegram.WebApp exists?", !!tg)
  return tg?.initData || null
}

export const expandTelegramApp = () => {
  const tg = (window as any).Telegram?.WebApp
  tg?.expand()
}